'use client';

import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { TrialSubscriptionSavings } from '@/components/flow/components/TrialSubscriptionSavings/TrialSubscriptionSavings';
import { DATA_KEYS } from '@/consts/dataKeys';

import { Subheader } from './subheader';

export function SubscriptionSavingsHeader({
  title,
  subtitle,
}: {
  title?: string;
  subtitle?: string;
}) {
  const { flags } = useDataProvider(DATA_KEYS.productSelection);

  return (
    <div className="cur-mt-6">
      <Subheader
        text={title || flags.priceSummaryHeaderText || '30-day trial box'}
      />
      <Typography className="cur-mt-2 cur-text-brand" size="body" weight="bold">
        {subtitle || (
          <>
            You&apos;re saving <TrialSubscriptionSavings />!
          </>
        )}
      </Typography>
    </div>
  );
}
